"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackDeleteSearchHistory = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
function trackDeleteSearchHistory(search_term) {
    const eventData = {
        eventName: enums_1.GA4EventName.ClickButton,
        feature_category: enums_1.GA4FeatureCategory.Search,
        click_element: enums_1.ClickElement.SearchHistoryDelete,
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        event: 'JS_Event',
        eventCategory: enums_1.EventCategory.Search,
        eventAction: enums_1.SearchEventType.DeleteHistory,
        eventLabel: search_term,
        eventData,
    });
}
exports.trackDeleteSearchHistory = trackDeleteSearchHistory;
//# sourceMappingURL=trackDeleteSearchHistory.js.map